import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { combineLatest, map } from 'rxjs';
import { HttpBaseService } from 'src/app/base/http-base.service';
import {
  getData,
  getGeneratedTranslations,
  saveLanguages,
  setLanguages,
  setTranslations,
  updateTranslations
} from '../actions/translation.actions';

@Injectable()
export class TranslationEffects {
  private actions$ = inject(Actions);
  private baseService = inject(HttpBaseService);
  private store = inject(Store);

  getData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getData),
        map((action: any) => {
          return combineLatest([
            this.baseService[action.apiConstants?.language.method](action.apiConstants.language),
            this.baseService[action.apiConstants?.translations.method](action.apiConstants.translations)
          ]).subscribe((results: any) => {
            if (results[0]) {
              this.store.dispatch(
                setLanguages({
                  languagesRes: results[0]
                })
              );
            } else {
              this.store.dispatch(
                setLanguages({
                  languagesRes: { languages: null }
                })
              );
            }
            this.store.dispatch(
              setTranslations({
                translationsData: {
                  languageData: results[1]
                }
              })
            );
          });
        })
      ),
    {
      dispatch: false
    }
  );

  getGeneratedTranslations$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getGeneratedTranslations),
        map((action: any) => {
          return this.baseService[action.apiConstants?.method](action.apiConstants).subscribe((results: any) => {
            this.store.dispatch(
              setTranslations({
                translationsData: {
                  languageData: results
                }
              })
            );
          });
        })
      ),
    {
      dispatch: false
    }
  );

  saveLanguages$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(saveLanguages),
        map((action: any) => {
          return this.baseService[action.saveApiConstants?.method](
            action.saveApiConstants,
            action.languagesData
          ).subscribe((res: any) => {
            this.store.dispatch(
              setLanguages({
                languagesRes: { languages: res }
              })
            );
          });
        })
      ),
    {
      dispatch: false
    }
  );

  updateTranslations$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(updateTranslations),
        map((action: any) => {
          return this.baseService[action.saveApiConstants?.method](
            action.saveApiConstants,
            action.translationsData
          ).subscribe((res: any) => {
            console.log(res);
          });
        })
      ),
    {
      dispatch: false
    }
  );
}
